import React from 'react';
import { Shape } from 'react-konva';

const MIN_SCREEN_STEP = 24;

const getVisibleStep = (gridSize, zoom) => {
  let step = gridSize;
  while (step * zoom < MIN_SCREEN_STEP) {
    step *= 2;
  }
  return step;
};

function GridOverlay({ width, height, gridSize = 16, zoom = 1 }) {
  if (!width || !height || !gridSize) {
    return null;
  }

  const safeZoom = Math.max(zoom, 0.01);
  const step = getVisibleStep(gridSize, safeZoom);
  const pixel = 1 / safeZoom;

  const sceneFunc = (context) => {
    const ctx = context._context;
    ctx.beginPath();
    for (let x = step; x < width; x += step) {
      ctx.moveTo(x, 0);
      ctx.lineTo(x, height);
    }
    for (let y = step; y < height; y += step) {
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
    }
    ctx.lineWidth = 2 * pixel;
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.12)';
    ctx.stroke();
    ctx.lineWidth = pixel;
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.18)';
    ctx.stroke();
  };

  return <Shape sceneFunc={sceneFunc} listening={false} perfectDrawEnabled={false} />;
}

export default GridOverlay;
